import React from 'react';
import { useTranslation } from 'react-i18next';

interface BetaModeModalProps {
  isVisible: boolean;
  onClose: () => void;
  onContinue: () => void;
  featureName?: string;
}

export const BetaModeModal: React.FC<BetaModeModalProps> = ({
  isVisible,
  onClose,
  onContinue,
  featureName
}) => {
  const { t } = useTranslation();

  if (!isVisible) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content beta-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{t('title', { ns: 'betaModal' })}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <div className="modal-body">
          {featureName === 'Pricing' ? (
            <div className="beta-content">
              <div className="beta-icon">🎉</div>
              <h3>{t('pricing.subtitle', { ns: 'betaModal' })}</h3>
              <p>
                {t('pricing.description', { ns: 'betaModal' })}
              </p>
              <p>
                {t('pricing.message', { ns: 'betaModal' })}
              </p>
              <div className="beta-benefits">
                <div className="benefit-item">
                  <span className="benefit-icon">🚀</span>
                  <span>{t('pricing.benefits.allFeatures', { ns: 'betaModal' })}</span>
                </div>
                <div className="benefit-item">
                  <span className="benefit-icon">💰</span>
                  <span>{t('pricing.benefits.noPayment', { ns: 'betaModal' })}</span>
                </div>
                <div className="benefit-item">
                  <span className="benefit-icon">⭐</span>
                  <span>{t('pricing.benefits.earlyAccess', { ns: 'betaModal' })}</span>
                </div>
                <div className="benefit-item">
                  <span className="benefit-icon">💡</span>
                  <span>{t('pricing.benefits.feedback', { ns: 'betaModal' })}</span>
                </div>
              </div>
              <div className="beta-note">
                <p>{t('pricing.note', { ns: 'betaModal' })}</p>
              </div>
            </div>
          ) : (
            <div className="beta-content">
              <div className="beta-icon">🚀</div>
              <h3>{t('subtitle', { ns: 'betaModal' })}</h3>
              <p>
                {featureName ? (
                  <>
                    <strong>{featureName}</strong> {t('featureDescription', { ns: 'betaModal' })}
                  </>
                ) : (
                  t('genericDescription', { ns: 'betaModal' })
                )}
              </p>
              <p>
                {t('feedbackMessage', { ns: 'betaModal' })}
              </p>
              <div className="beta-benefits">
                <div className="benefit-item">
                  <span className="benefit-icon">✅</span>
                  <span>{t('benefits.noPayment', { ns: 'betaModal' })}</span>
                </div>
                <div className="benefit-item">
                  <span className="benefit-icon">🎯</span>
                  <span>{t('benefits.fullAccess', { ns: 'betaModal' })}</span>
                </div>
                <div className="benefit-item">
                  <span className="benefit-icon">💬</span>
                  <span>{t('benefits.helpImprove', { ns: 'betaModal' })}</span>
                </div>
              </div>
            </div>
          )}

          <div className="modal-actions">
            <button 
              className="btn btn-secondary"
              onClick={onClose}
            >
              {t('actions.cancel', { ns: 'common' })}
            </button>
            <button 
              className="btn btn-primary"
              onClick={onContinue}
            >
              {featureName === 'Pricing' ? t('pricing.cta', { ns: 'betaModal' }) : t('actions.continue', { ns: 'betaModal' })}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}; 